import { FormValues } from "@/hooks/useAudioProcessing";
import { UploadStatus } from "..";
import { type Format } from "@/lib/clients/formats";

// アップロードできるファイル形式
export const VALID_EXTENSIONS = ['wav', 'mp3', 'mpeg', 'mp4', 'ogg', 'webm', 'm4a'];

export type StructureDefinition = {
  id: string;
  name: string;
  definition: string;
  created_at?: string;
};

export type AudioUploadFormProps = {
  onSubmit: (data: FormValues & { customPrompt?: string; structureDefinitionId?: string }) => void;
  isSubmitting: boolean;
  status: UploadStatus;
  audioUrl: string;
  fileName: string;
  structureDefinitions?: StructureDefinition[];
  formats?: Format[];
  isFormatsLoading?: boolean;
}; 